import { CIcon } from '~/icons/types'

export const ciBedroom: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.75 11.039a1.775 1.775 0 0 0-1.7-1.836h-.216V6.231a2.47 2.47 0 0 0-2.455-2.481H5.62a2.469 2.469 0 0 0-2.451 2.481V9.2h-.217a1.775 1.775 0 0 0-1.7 1.836V16c0 1.262.748 2.25 1.7 2.25h.3v1.25a.75.75 0 1 0 1.5 0v-1.25h14.5v1.25a.75.75 0 1 0 1.5 0v-1.25h.292c.955 0 1.7-.988 1.7-2.25v-1.5l.006-3.461ZM4.669 6.231a.968.968 0 0 1 .951-.981h12.759a.968.968 0 0 1 .952.981V9.2h-2.6a3.322 3.322 0 0 0-3.383-2.336h-2.695A3.322 3.322 0 0 0 7.27 9.2h-2.6l-.001-2.969ZM15.144 9.2H8.856a2.112 2.112 0 0 1 1.8-.836h2.694a2.112 2.112 0 0 1 1.794.836ZM2.75 11.039c0-.205.12-.336.2-.336h18.1c.083 0 .2.131.2.336v2.71H2.75v-2.71Zm18.3 5.711H20l-15.952.008c-.016 0-.029-.009-.046-.009-.017 0-.029.008-.045.009H3A1.012 1.012 0 0 1 2.75 16v-.751h18.5V16c.009.265-.062.526-.203.75h.003Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bedroom',
  type: 'light'
}
